import { Fragment, useEffect } from 'react';
import { useConversation } from '../../contexts/conversation';
import { ActorType, StateType, WidgetName } from '../../enums/conversation';
import ChatInput from '../ChatInput';
import TypingLoader from '../Loader/Typing';
import Message from '../Message';
import AgentAssignment from '../Message/AgentAssignment';
import ConversationResolution from '../Message/ConversationResolution';
import { Message as MessageType, MessageWidget } from '../Message/index.types';
import MessageBubble from '../MessageBubble';
import Day from './Day';
import MessageErrorBoundary from './MessageErrorBoundary';

function MessageWrapper() {
    const { messages, typing } = useConversation();

    useEffect(() => {
        const chatWrapper = document.getElementById('chat-wrapper');
        if (!chatWrapper) return;
        setTimeout(() => chatWrapper.classList.add('scroll-smooth'));
    }, []);

    useEffect(() => {
        const messagesList = document.querySelectorAll('.message');
        const { length } = messagesList;
        if (length) {
            messagesList[length - 1].scrollIntoView();
        }
    });

    const renderStateWidget = (widget: MessageWidget) => {
        const { actorName, type } = widget.parameters;

        switch (type) {
            case StateType.ASSIGNMENT:
                return <AgentAssignment actorName={actorName as string} />;

            case StateType.RESOLUTION:
                return <ConversationResolution actorName={actorName as string} />;

            default:
                return null;
        }
    };

    const renderMessage = (message: MessageType, index: number) => {
        const isLastMessage = index === messages.length - 1;

        const stateWidget = message.messageParts.filter((item) => item.widget?.name === WidgetName.STATE)[0];
        if (stateWidget) return renderStateWidget(stateWidget.widget!);

        return (
            <MessageErrorBoundary>
                <div className='message flex flex-col gap-10'>
                    <Message message={message} isLastMessage={isLastMessage} />
                </div>
            </MessageErrorBoundary>
        );
    };

    if (!messages.length) return null;

    return (
        <>
            {messages.map((item, index) => (
                <Fragment key={item._id}>
                    <Day date={item.createdAt as number} lastDate={messages[index - 1]?.createdAt as number} />
                    {renderMessage(item, index)}
                </Fragment>
            ))}
            <ChatInput />
            {typing && (
                <div>
                    <div className='flex flex-col gap-5 pr-40 pl-20'>
                        <MessageBubble actor={{ type: ActorType.BOT }}>
                            <TypingLoader />
                        </MessageBubble>
                    </div>
                </div>
            )}
        </>
    );
}

export default MessageWrapper;
